module.exports = __webpack_public_path__ + "img/bannerEquipe.be5cb0fc.jpg";